import type { Slardar } from '@meego/biz-utils/src/monitors/slardar';

export const getSlardar: () => {
  sendLog: InstanceType<typeof Slardar>['sendLog'];
  sendCustom: InstanceType<typeof Slardar>['sendCustom'];
  addInterceptor: InstanceType<typeof Slardar>['addInterceptor'];
} = () => {
  return {
    sendLog: (...args) => {
      import('@meego/utils/src/envs').then(() => {
        import('@meego/biz-utils/src/monitors/slardar').then(({ slardar }) => {
          slardar.sendLog.call(this, ...args);
        });
      });
    },
    sendCustom: (...args) => {
      import('@meego/utils/src/envs').then(() => {
        import('@meego/biz-utils/src/monitors/slardar').then(({ slardar }) => {
          slardar.sendCustom.call(this, ...args);
        });
      });
    },
    addInterceptor: (...args) => {
      import('@meego/biz-utils/src/monitors/slardar').then(({ slardar }) => {
        slardar.addInterceptor(...args);
      });
    },
  };
};
